"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteAssetsClientFactorySym = exports.SiteAssetsClientSym = void 0;
exports.SiteAssetsClientSym = Symbol('SiteAssetsClient');
exports.SiteAssetsClientFactorySym = Symbol('SiteAssetsClientFactory');
//# sourceMappingURL=siteAssetsClient.js.map